import ExpensesSelector from "../utils/ExpensesSelector";
import Select from "react-select";
import {
  Modal,
  Form,
  Button,
  InputGroup,
  Table,
  Dropdown,
  Row,
  DropdownButton,
  Accordion,
  Badge,
} from "react-bootstrap";
import { useEffect, useMemo, useState } from "react";
import CurrencyCustomInput from "../utils/CurrencyCustomInput";
import MagnifyIcon from "mdi-react/MagnifyIcon";

import DateTime from "react-datetime";
import { paymentTerms } from "../Fleet/utils";
import NumberCustomInput from "../utils/NumberCustomInput";
import CachedIcon from "mdi-react/CachedIcon";
import { Popover } from "react-tiny-popover";
import currency from "currency.js";
import { currenciesOptions } from "../../utils/currencies";

const PurchaseTypeOptions = [
  {
    label: "Direct Purchase (Cash)",
    value: "Direct Purchase (Cash)",
  },
  {
    label: "Bank Financed",
    value: "Bank Financed",
  },
  {
    label: "Hire Purchase",
    value: "Hire Purchase",
  },
  {
    label: "Gift",
    value: "Gift",
  },
];

const paymentMethod = [
  // {
  //   // icon: <CashSelectIcon />,
  //   label: "CASH",
  //   value: "CASH",
  // },
  // {
  //   // icon: <DirectTransferSelectIcon />,
  //   label: "Direct Bank Transfer",
  //   value: "Direct Bank Transfer",
  // },

  // {
  //   label: "CASH BY WIRE TRANSFER",
  //   value: "CASH BY WIRE TRANSFER",
  // },
  {
    // icon: <CreditMemoSelectIcon />,
    label: "CLEAN CREDIT",
    value: "CLEAN CREDIT",
  },
  {
    label: "BANK GUARANTEE",
    value: "BANK GUARANTEE",
  },
  {
    label: "OVER DRAFT",
    value: "OVER DRAFT",
  },
];

const paymentMethodForDirectBankTransfer = [
  {
    // icon: <CashSelectIcon />,
    label: "CASH",
    value: "CASH",
  },
  {
    // icon: <DirectTransferSelectIcon />,
    label: "Direct Bank Transfer",
    value: "Direct Bank Transfer",
  },
];

const getOrdinal = (n) => {
  const suffixes = ["th", "st", "nd", "rd"];
  const remainder = n % 100;
  return (
    n + (suffixes[(remainder - 20) % 10] || suffixes[remainder] || suffixes[0])
  );
};

export default function PurchaseTypeAndAmount({
  formik,
  bankSelectOptions,
  data,
  refetchSetup,
  incentiveSetupData,
  incentiveSetupIsLoading,
}) {
  const [paymentMethods, setPaymentMethods] = useState(paymentMethod);

  const currencySymbol = useMemo(() => {
    const foundCurrency = currenciesOptions.find(
      (el) => el.cc === formik.values.currency,
    );
    return foundCurrency ? foundCurrency.symbol : "";
  }, [formik.values.currency]);

  const [
    showJournalLiabilityAccountPopover,
    setShowLiabilityAccountPopover,
  ] = useState(false);
  const [
    showJournalIncomeAccountPopover,
    setShowIncomeAccountPopover,
  ] = useState(false);
  const [
    showJournalAccountPayablePopover,
    setShowAccountPayablePopover,
  ] = useState(false);

  // useEffect(() => {
  //   if (
  //     formik.values.repaymentPlan === "byAmount" &&
  //     formik.values.deductionAmount &&
  //     formik.values.UnitCost &&
  //     formik.values.Quantity
  //   ) {
  //     const total =
  //       Number(formik.values.UnitCost) * Number(formik.values.Quantity);
  //     const deduction = Number(formik.values.deductionAmount);
  //     const installmentsAmount = Math.ceil(total / deduction);

  //     // Last installment is whatever is left after the regular installments
  //     const lastInstallmentAmount =
  //       total - deduction * (installmentsAmount - 1);

  //     formik.setFieldValue("numberOfInstallments", installmentsAmount);
  //     formik.setFieldValue("lastInstallmentAmount", lastInstallmentAmount);
  //   } else {
  //     formik.setFieldValue("numberOfInstallments", "");
  //   }
  // }, [
  //   formik.values.deductionAmount,
  //   formik.values.UnitCost,
  //   formik.values.Quantity,
  //   formik.values.repaymentPlan,
  // ]);

  useEffect(() => {
    if (
      formik.values.repaymentPlan === "byAmount" &&
      formik.values.deductionAmount &&
      formik.values.UnitCost &&
      formik.values.Quantity
    ) {
      const total =
        Number(formik.values.UnitCost) * Number(formik.values.Quantity);
      const deduction = Number(formik.values.deductionAmount);
      const installmentsAmount = Math.ceil(total / deduction);

      // Last installment is whatever is left after the regular installments
      const lastInstallmentAmount =
        total - deduction * (installmentsAmount - 1);

      const MAX_INSTALLMENTS = 500;
      if (
        !Number.isFinite(installmentsAmount) ||
        installmentsAmount <= 0 ||
        installmentsAmount > MAX_INSTALLMENTS
      ) {
        formik.setFieldValue("numberOfInstallments", installmentsAmount);
        formik.setFieldValue("lastInstallmentAmount", lastInstallmentAmount);
        formik.setFieldValue("installmentBreakdown", []);
        return;
      }

      // // Build the full per-installment breakdown
      const installmentBreakdown = Array.from(
        { length: installmentsAmount },
        (_, index) => {
          const installmentNumber = index + 1;
          const isLast = installmentNumber === installmentsAmount;

          return {
            installmentNumber,
            amount: isLast ? lastInstallmentAmount : deduction,
            isLast,
          };
        },
      );

      formik.setFieldValue("numberOfInstallments", installmentsAmount);
      formik.setFieldValue("lastInstallmentAmount", lastInstallmentAmount);
      formik.setFieldValue("installmentBreakdown", installmentBreakdown);
    } else {
      formik.setFieldValue("numberOfInstallments", "");
      formik.setFieldValue("lastInstallmentAmount", "");
      formik.setFieldValue("installmentBreakdown", []);
    }
  }, [
    formik.values.deductionAmount,
    formik.values.UnitCost,
    formik.values.Quantity,
    formik.values.repaymentPlan,
  ]);

  const handleLiabilityAccount = (account) => {
    formik.setFieldValue("liabilityAccountID", account?.AccountID);
    formik.setFieldValue("liabilityAccountDescription", account?.Description);
    setShowLiabilityAccountPopover(false);
  };
  const handleIncomeAccount = (account) => {
    formik.setFieldValue("incomeAccountID", account?.AccountID);
    formik.setFieldValue("incomeAccountDescription", account?.Description);
    setShowIncomeAccountPopover(false);
  };
  const handleAccountPayable = (account) => {
    formik.setFieldValue("accountPayableID", account?.AccountID);
    formik.setFieldValue("accountPayableDescription", account?.Description);
    setShowAccountPayablePopover(false);
  };

  const fieldsToClearByPurchaseType = {
    "Direct Purchase (Cash)": [
      "payTerm",
      "nextInstallment",
      "nextInstallmentUnit",
      "liabilityAccount",
      "scheme",
      "activationStartDate",
      "incomeAccountID",
    ],
    "Bank Financed": ["scheme", "incomeAccountID"],
    "Hire Purchase": ["bank", "liabilityAccount", "incomeAccountID"],
    Gift: [
      "bank",
      "payTerm",
      "nextInstallment",
      "nextInstallmentUnit",
      "liabilityAccountID",
      "scheme",
      "activationStartDate",
    ],
  };

  const handleClearField = (value) => {
    const fieldsToClear = fieldsToClearByPurchaseType[value] || [];
    fieldsToClear.forEach((field) => formik.setFieldValue(field, ""));
  };

  return (
    <div>
      <hr />
      <Form.Group className=" mb-3 pb-2">
        <Form.Label className="mb-1">Purchase Type</Form.Label>
        <Select
          classNames={{
            control: () =>
              formik.touched.PurchaseType && formik.errors.PurchaseType
                ? "is-invalid-select"
                : "",
          }}
          name="PurchaseType"
          options={PurchaseTypeOptions}
          classNamePrefix={"form-select"}
          value={PurchaseTypeOptions.find(
            (type) => type?.value === formik?.values?.PurchaseType,
          )}
          onChange={(value) => {
            if (value.value === "Direct Purchase (Cash)") {
              setPaymentMethods(paymentMethodForDirectBankTransfer);
            } else {
              setPaymentMethods(paymentMethod);
            }
            formik.setFieldValue("PurchaseType", value?.value);
            handleClearField(value?.value);
          }}
        />

        {formik.touched.PurchaseType && !!formik.errors.PurchaseType ? (
          <span className="text-danger mt-2">{formik.errors.PurchaseType}</span>
        ) : null}
      </Form.Group>

      {["Direct Purchase (Cash)", "Bank Financed"].includes(
        formik.values.PurchaseType,
      ) && (
        <div>
          <Form.Group className="mb-3 pb-2">
            <Form.Label className="mb-1">Bank</Form.Label>
            <Select
              classNamePrefix={"form-select"}
              options={bankSelectOptions()}
              value={
                bankSelectOptions().find(
                  (el) => el.value === formik.values.bank,
                ) || ""
              }
              onChange={(selected) => {
                formik.setFieldValue("bank", selected.value);
                // if (selected?.Vendor_ID) {
                //   formik.setFieldValue("Vendor_ID", selected.Vendor_ID);
                // }
              }}
              className={
                formik.touched.bank && !!formik.errors.bank ? "is-invalid" : ""
              }
              isDisabled={[
                "Direct Purchase (Cash)" /* "CASH BY WIRE TRANSFER" */,
              ].includes(formik.values.PurchaseType)}
            />
            {formik.touched.bank && !!formik.errors.bank ? (
              <span className="text-danger mt-2">{formik.errors.bank}</span>
            ) : null}
          </Form.Group>
        </div>
      )}

      {formik.values?.PurchaseType === "Hire Purchase" && (
        // <div className="row">
        //   <Form.Group className="mb-3 pb-2">
        //     <Form.Label className="mb-1">
        //       Scheme <CachedIcon onClick={() => refetchSetup()} />{" "}
        //     </Form.Label>
        //     <Select
        //       classNamePrefix={"form-select"}
        //       options={incentiveSetupData?.scheme || []}
        //       value={
        //         incentiveSetupData?.scheme?.find(
        //           (el) => el.value === formik.values.scheme,
        //         ) || ""
        //       }
        //       onChange={({ value, ...rest }) => {
        //         const items = rest?.items ?? [];
        //         const exactRuleForInstallment = items?.find(
        //           (el) => el?.isInstallment === true,
        //         );

        //         let deductibleAmount = 0;
        //         if (exactRuleForInstallment?.amountType === "fixed") {
        //           deductibleAmount = exactRuleForInstallment?.amount || 0;
        //         } else {
        //           // calculate the percentage to get the deductible amount
        //           if (formik.values.UnitCost && formik.values.Quantity) {
        //             deductibleAmount =
        //               (exactRuleForInstallment?.amount / 100) *
        //               formik.values.UnitCost *
        //               formik.values.Quantity;
        //           }
        //         }

        //         const startDate = exactRuleForInstallment?.startDate;
        //         const frequency =
        //           exactRuleForInstallment?.frequency || "monthly"; // monthly,  daily, weekly, yearly

        //         // also check the frequency
        //         if (frequency === "yearly") {
        //           formik.setFieldValue("payTermByAmount", "years");
        //         } else if (frequency === "daily") {
        //           formik.setFieldValue("payTermByAmount", "days");
        //         } else if (frequency === "weekly") {
        //           formik.setFieldValue("payTermByAmount", "weeks");
        //         } else {
        //           formik.setFieldValue("payTermByAmount", "months");
        //         }

        //         formik.setFieldValue("nextInstallment", 1);

        //         formik.setFieldValue("scheme", value);
        //         formik.setFieldValue(
        //           "schemeItemId",
        //           exactRuleForInstallment?.id,
        //         );
        //         // formik.setFieldValue(
        //         //   "activationStartDate",
        //         //   new Date(startDate),
        //         // );
        //         formik.setFieldValue(
        //           "deductionAmount",
        //           Number(deductibleAmount),
        //         );
        //         formik.setFieldValue("Vendor", rest?.vendorId);

        //         handleAccountPayable(
        //           exactRuleForInstallment?.debitAccountDetails,
        //         );

        //         // set the laibaility account here
        //       }}
        //       isLoading={incentiveSetupIsLoading}
        //       // isDisabled={["CASH" /* "CASH BY WIRE TRANSFER" */].includes(
        //       //   formik.values.PaymentType,
        //       // )}
        //     />

        //     {formik.touched.scheme && !!formik.errors.scheme ? (
        //       <span className="text-danger mt-2">{formik.errors.scheme}</span>
        //     ) : null}
        //   </Form.Group>
        // </div>

        <div className="row">
          <Form.Group className="mb-3 pb-2">
            <Form.Label className="mb-1">
              Scheme <CachedIcon onClick={() => refetchSetup()} />{" "}
            </Form.Label>
            <Select
              classNamePrefix={"form-select"}
              options={incentiveSetupData?.scheme || []}
              value={
                incentiveSetupData?.scheme?.find(
                  (el) => el.value === formik.values.scheme,
                ) || null
              }
              onChange={({ value, ...rest }) => {
                const items = rest?.items ?? [];
                const exactRuleForInstallment = items?.find(
                  (el) => el?.isInstallment === true,
                );

                let deductibleAmount = 0;
                if (exactRuleForInstallment?.amountType === "fixed") {
                  deductibleAmount = exactRuleForInstallment?.amount ?? 0;
                } else {
                  // calculate the percentage to get the deductible amount
                  if (formik.values.UnitCost && formik.values.Quantity) {
                    deductibleAmount =
                      ((exactRuleForInstallment?.amount ?? 0) / 100) *
                      formik.values.UnitCost *
                      formik.values.Quantity;
                  }
                }

                const startDate = exactRuleForInstallment?.startDate ?? null;
                const frequency =
                  exactRuleForInstallment?.frequency || "monthly"; // monthly,  daily, weekly, yearly

                // also check the frequency
                if (frequency === "yearly") {
                  formik.setFieldValue("payTermByAmount", "years");
                } else if (frequency === "daily") {
                  formik.setFieldValue("payTermByAmount", "days");
                } else if (frequency === "weekly") {
                  formik.setFieldValue("payTermByAmount", "weeks");
                } else {
                  formik.setFieldValue("payTermByAmount", "months");
                }

                formik.setFieldValue("nextInstallment", 1);

                formik.setFieldValue("scheme", value ?? "");
                formik.setFieldValue(
                  "schemeItemId",
                  exactRuleForInstallment?.id ?? "",
                );
                // formik.setFieldValue(
                //   "activationStartDate",
                //   startDate ? new Date(startDate) : null,
                // );
                formik.setFieldValue(
                  "deductionAmount",
                  Number(deductibleAmount) || 0,
                );
                formik.setFieldValue("Vendor", rest?.vendorId ?? "");

                handleAccountPayable(
                  exactRuleForInstallment?.debitAccountDetails ?? null,
                );

                // set the laibaility account here
              }}
              isLoading={incentiveSetupIsLoading}
              // isDisabled={["CASH" /* "CASH BY WIRE TRANSFER" */].includes(
              //   formik.values.PaymentType,
              // )}
            />

            {formik.touched.scheme && !!formik.errors.scheme ? (
              <span className="text-danger mt-2">{formik.errors.scheme}</span>
            ) : null}
          </Form.Group>
        </div>
      )}

      {["Bank Financed", "Hire Purchase"].includes(
        formik.values.PurchaseType,
      ) && (
        <div>
          {/* Repayment Plan Toggle */}
          <Form.Group className="mb-3 pb-2">
            <Form.Label className="mb-2">Amortized by</Form.Label>
            <div className="d-flex align-items-center gap-3">
              <span
                className={
                  formik.values.repaymentPlan === "byAmount" ||
                  !formik.values.repaymentPlan
                    ? "fw-semibold"
                    : "text-muted"
                }
              >
                Fixed Amount
              </span>
              <Form.Check
                type="switch"
                disabled={formik?.values?.PurchaseType === "Hire Purchase"}
                id="repayment-plan-switch"
                checked={formik.values.repaymentPlan === "byInstallment"}
                onChange={(e) => {
                  formik.setFieldValue(
                    "repaymentPlan",
                    e.target.checked ? "byInstallment" : "byAmount",
                  );
                  // clear the other plan's fields
                  formik.setFieldValue("payTerm", "");
                  formik.setFieldValue("nextInstallment", "");
                  formik.setFieldValue("nextInstallmentUnit", "");
                  formik.setFieldValue("deductionAmount", "");
                  formik.setFieldValue("payTermByAmount", "");
                  formik.setFieldValue("payTermByAmount", "");
                  formik.setFieldValue("accountPayableID", "");
                  formik.setFieldValue("incomeAccountID", "");
                  formik.setFieldValue("liabilityAccountID", "");
                }}
              />
              <span
                className={
                  formik.values.repaymentPlan === "byInstallment"
                    ? "fw-semibold"
                    : "text-muted"
                }
              >
                Payment Period
              </span>
            </div>
          </Form.Group>

          {/* Option A: By Amount */}
          {!formik.values.repaymentPlan ||
          formik.values.repaymentPlan === "byAmount" ? (
            <div className=" row">
              <Form.Group className="mb-3 pb-2 col-md-6">
                <Form.Label className="mb-1">Payment Term</Form.Label>
                <Select
                  isDisabled={formik?.values?.PurchaseType === "Hire Purchase"}
                  classNamePrefix={"form-select"}
                  options={[
                    { label: "Days", value: "days" },
                    { label: "Weeks", value: "weeks" },
                    { label: "Months", value: "months" },
                    { label: "Years", value: "years" },
                  ]}
                  value={
                    [
                      { label: "Days", value: "days" },
                      { label: "Weeks", value: "weeks" },
                      { label: "Months", value: "months" },
                      { label: "Years", value: "years" },
                    ].find(
                      (el) => el.value === formik.values.payTermByAmount,
                    ) || ""
                  }
                  onChange={({ value }) => {
                    formik.setFieldValue("payTermByAmount", value);
                  }}
                />
                {formik.touched.payTermByAmount &&
                !!formik.errors.payTermByAmount ? (
                  <span className="text-danger mt-2">
                    {formik.errors.payTermByAmount}
                  </span>
                ) : null}
              </Form.Group>

              <Form.Group className="mb-3 pb-2 col-md-6">
                <Form.Label className="mb-1">
                  Every ({formik?.values?.payTermByAmount})
                </Form.Label>
                <InputGroup>
                  <NumberCustomInput
                    name="nextInstallment"
                    value={formik.values.nextInstallment}
                    onValueChange={(value, name) => {
                      formik.setFieldValue(name, value);
                    }}
                    disabled={[
                      "Direct Purchase (Cash)",
                      "Hire Purchase",
                    ].includes(formik.values.PurchaseType)}
                  />
                </InputGroup>
                {formik.touched.nextInstallment &&
                !!formik.errors.nextInstallment ? (
                  <span className="text-danger mt-2">
                    {formik.errors.nextInstallment}
                  </span>
                ) : null}
              </Form.Group>

              <Form.Group className="mb-3 pb-2">
                <Form.Label className="mb-1">Deductible Amount</Form.Label>
                <InputGroup>
                  <CurrencyCustomInput
                    readOnly={formik?.values?.PurchaseType === "Hire Purchase"}
                    name="deductionAmount"
                    value={formik.values.deductionAmount}
                    onValueChange={(value, name) => {
                      formik.setFieldValue(name, value);
                    }}
                    isInvalid={
                      formik.touched.deductionAmount &&
                      !!formik.errors.deductionAmount
                    }
                    placeholder="0.00"
                  />
                </InputGroup>
                {formik.touched.deductionAmount &&
                !!formik.errors.deductionAmount ? (
                  <span className="text-danger mt-2">
                    {formik.errors.deductionAmount}
                  </span>
                ) : null}

                {/* <Form.Text className="text-muted">
                  {formik.values.lastInstallmentAmount !==
                    formik.values.deductionAmount && (
                    <b>
                      Note: Last installment is{" "}
                      {currency(formik?.values?.lastInstallmentAmount).format({
                        symbol: currencySymbol,
                        separator: ",",
                      })}
                    </b>
                  )}
                </Form.Text> */}
              </Form.Group>

              {/* Derived: Number of Installments */}
              {formik.values.deductionAmount &&
              formik.values.UnitCost &&
              formik.values.Quantity ? (
                <Form.Group className="mb-3 pb-2">
                  <Form.Label className="mb-1">
                    Number of Installments
                  </Form.Label>

                  <Form.Control
                    value={formik.values.numberOfInstallments || ""}
                    readOnly
                    disabled
                  />
                </Form.Group>
              ) : null}
            </div>
          ) : null}

          {formik?.values?.installmentBreakdown?.length > 0 && (
            <div className="installment-breakdown-accordion">
              <Accordion className=" mb-3">
                <Accordion.Item
                  className=" px-0 mx-0"
                  eventKey="0"
                  style={{ backgroundColor: "white" }}
                >
                  <Accordion.Header
                    className=" br-transparent px-0 mx-0"
                    style={{ backgroundColor: "white" }}
                  >
                    Installment Breakdown &nbsp;
                    <Badge bg="" className="ms-2">
                      {formik.values.numberOfInstallments} installments
                    </Badge>
                  </Accordion.Header>
                  <Accordion.Body className=" ">
                    <Table responsive className="mb-0">
                      <tbody>
                        {formik.values.installmentBreakdown.map((inst) => (
                          <tr
                            key={inst.installmentNumber}
                            className={inst.isLast ? "table-warning" : ""}
                          >
                            <td>
                              {getOrdinal(inst.installmentNumber)} Installment
                              {inst.isLast && (
                                <Badge
                                  bg="warning"
                                  text="dark"
                                  className="ms-2"
                                >
                                  Final
                                </Badge>
                              )}
                            </td>
                            <td className="text-end">
                              {currency(inst.amount).format({
                                symbol: currencySymbol,
                                separator: ",",
                              })}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          )}

          {/* Option B: By Installment */}
          {formik.values.repaymentPlan === "byInstallment" && (
            <div>
              <Form.Group className="mb-3 pb-2">
                <Form.Label className="mb-1">Payment Term</Form.Label>
                <Select
                  classNamePrefix={"form-select"}
                  options={paymentTerms}
                  value={
                    paymentTerms?.find(
                      (el) => el.value === formik.values.payTerm,
                    ) || ""
                  }
                  onChange={({ value }) => {
                    formik.setFieldValue("payTerm", value);
                  }}
                  isDisabled={["Direct Purchase (Cash)"].includes(
                    formik.values.PurchaseType,
                  )}
                />
                {formik.touched.payTerm && !!formik.errors.payTerm ? (
                  <span className="text-danger mt-2">
                    {formik.errors.payTerm}
                  </span>
                ) : null}
              </Form.Group>

              <div className="row">
                <Form.Group className="mb-3 pb-2 col-md-6">
                  <Form.Label>Duration</Form.Label>
                  <Select
                    classNamePrefix={"form-select"}
                    options={[
                      { label: "Days", value: "days" },
                      { label: "Weeks", value: "weeks" },
                      { label: "Months", value: "months" },
                      { label: "Years", value: "years" },
                    ]}
                    value={
                      [
                        { label: "Days", value: "days" },
                        { label: "Weeks", value: "weeks" },
                        { label: "Months", value: "months" },
                        { label: "Years", value: "years" },
                      ].find(
                        (el) => el.value === formik.values.nextInstallmentUnit,
                      ) || ""
                    }
                    onChange={({ value }) => {
                      formik.setFieldValue("nextInstallmentUnit", value);
                    }}
                  />
                </Form.Group>

                {/* <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1" >
               Deductible Amount
              </Form.Label>
              <CurrencyCustomInput
                currencySymbol={currencySymbol}
                placeholder="0.00"
                value={

                }
                readOnly
              />
              <Form.Control.Feedback type="invalid" />
            </Form.Group> */}

                <Form.Group className="mb-3 pb-2 col-md-6">
                  <Form.Label className="mb-1">
                    Every ({formik?.values?.nextInstallmentUnit})
                  </Form.Label>
                  <InputGroup>
                    <NumberCustomInput
                      name="nextInstallment"
                      value={formik.values.nextInstallment}
                      onValueChange={(value, name) => {
                        formik.setFieldValue(name, value);
                      }}
                      disabled={["Direct Purchase (Cash)"].includes(
                        formik.values.PurchaseType,
                      )}
                    />
                  </InputGroup>
                  {formik.touched.nextInstallment &&
                  !!formik.errors.nextInstallment ? (
                    <span className="text-danger mt-2">
                      {formik.errors.nextInstallment}
                    </span>
                  ) : null}
                </Form.Group>
              </div>
            </div>
          )}
        </div>
      )}

      {["Bank Financed"].includes(formik.values.PurchaseType) && (
        <Form.Group className="mb-3">
          <Form.Label>Controlling Account (liability account)</Form.Label>
          <InputGroup hasValidation>
            <Form.Control
              name="liabilityAccountID"
              placeholder="Select liability Account"
              value={`${formik.values?.liabilityAccountID || "..."} / ${formik
                .values?.liabilityAccountDescription || "..."}`}
              onChange={() => {}}
              readOnly
              isInvalid={
                formik.touched.liabilityAccountID &&
                !!formik.errors.liabilityAccountID
              }
            />

            <Popover
              isOpen={showJournalLiabilityAccountPopover}
              onClickOutside={() => setShowLiabilityAccountPopover(false)}
              content={() => (
                <ExpensesSelector
                  handleSelectedExpense={handleLiabilityAccount}
                  usage={"chart of accounts"}
                  Type="CURRENT LIABILITIES"
                  onHide={() => setShowLiabilityAccountPopover(false)}
                  dispatchKeyForCreatedAccount={
                    "JOURNAL_INCENTIVE_ACCOUNT_CREATED"
                  }
                />
              )}
              position="bottom"
            >
              <InputGroup.Text
                onClick={() => setShowLiabilityAccountPopover(true)}
              >
                <MagnifyIcon />
              </InputGroup.Text>
            </Popover>
          </InputGroup>

          <Form.Control.Feedback type="invalid">
            {formik.errors.liabilityAccountID}
          </Form.Control.Feedback>
        </Form.Group>
      )}
      {["Hire Purchase"].includes(formik.values.PurchaseType) && (
        <Form.Group className="mb-3">
          <Form.Label>Controlling Account</Form.Label>
          <InputGroup hasValidation>
            <Form.Control
              name="accountPayableID"
              placeholder="Select liability Account"
              value={`${formik.values?.accountPayableID || "..."} / ${formik
                .values?.accountPayableDescription || "..."}`}
              onChange={() => {}}
              readOnly
              isInvalid={
                formik.touched.accountPayableID &&
                !!formik.errors.accountPayableID
              }
            />

            {/* <Popover
              isOpen={showJournalAccountPayablePopover}
              onClickOutside={() => setShowAccountPayablePopover(false)}
              content={() => (
                <ExpensesSelector
                  handleSelectedExpense={handleAccountPayable}
                  Description={formik?.values?.accountPayableID}
                  onHide={() => setShowAccountPayablePopover(false)}
                  dispatchKeyForCreatedAccount={
                    "JOURNAL_INCENTIVE_ACCOUNT_CREATED"
                  }
                />
              )}
              position="bottom"
            >
              <InputGroup.Text
                onClick={() => setShowAccountPayablePopover(true)}
              >
                <MagnifyIcon />
              </InputGroup.Text>
            </Popover> */}
          </InputGroup>

          <Form.Control.Feedback type="invalid">
            {formik.errors.liabilityAccountID}
          </Form.Control.Feedback>
        </Form.Group>
      )}

      {["Gift"].includes(formik.values.PurchaseType) && (
        <Form.Group className="mb-3">
          <Form.Label>Income Account</Form.Label>
          <InputGroup hasValidation>
            <Form.Control
              name="incomeAccountID"
              placeholder="Select income Account"
              value={`${formik.values?.incomeAccountID || "..."} / ${formik
                .values?.incomeAccountDescription || "..."}`}
              onChange={() => {}}
              readOnly
              isInvalid={
                formik.touched.incomeAccountID &&
                !!formik.errors.incomeAccountID
              }
            />

            <Popover
              isOpen={showJournalIncomeAccountPopover}
              onClickOutside={() => setShowIncomeAccountPopover(false)}
              content={() => (
                <ExpensesSelector
                  handleSelectedExpense={handleIncomeAccount}
                  usage={"chart of accounts"}
                  Type="INCOME"
                  onHide={() => setShowIncomeAccountPopover(false)}
                  dispatchKeyForCreatedAccount={
                    "JOURNAL_INCENTIVE_ACCOUNT_CREATED"
                  }
                />
              )}
              position="bottom"
            >
              <InputGroup.Text
                onClick={() => setShowIncomeAccountPopover(true)}
              >
                <MagnifyIcon />
              </InputGroup.Text>
            </Popover>
          </InputGroup>

          <Form.Control.Feedback type="invalid">
            {formik.errors.incomeAccountID}
          </Form.Control.Feedback>
        </Form.Group>
      )}

      {["Hire Purchase", "Bank Financed"].includes(
        formik.values.PurchaseType,
      ) && (
        <Form.Group className="col-12 mb-3 pb-2">
          <Form.Label className="mb-1">Activation Date</Form.Label>
          <DateTime
            dateFormat="MMM DD, YYYY"
            timeFormat={false}
            closeOnSelect={true}
            closeOnClickOutside={true}
            name="activationStartDate"
            inputProps={{
              className: `date-input form-control ${
                formik.touched.activationStartDate &&
                !!formik.errors.activationStartDate
                  ? "is-invalid"
                  : ""
              }`,
              placeholder: "Select date",
              readOnly: true,
            }}
            value={formik.values.activationStartDate}
            onChange={(date) => {
              formik.setFieldValue("activationStartDate", date, true);
            }}
            onBlur={() => formik.setFieldTouched("activationStartDate", true)}
          />
          {formik.touched.activationStartDate &&
          !!formik.errors.activationStartDate ? (
            <span className="custom-invalid-feedback">
              {formik.errors.activationStartDate}
            </span>
          ) : null}
        </Form.Group>
      )}

      <hr />
    </div>
  );
}
